import styled from 'styled-components'

export const View = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.flexDirection ? props.flexDirection : 'column')};
  align-items: ${(props) => (props.alignItems ? props.alignItems : 'stretch')};

  ${(props) => props.gap && `gap: ${props.theme.spacing[props.gap]}px;`}
`
